import { PortfolioItem } from "@/pages/Portfolio";
import { PortfolioDataItem } from "@/types/types";

interface CreativeGalleryProps {
  group: PortfolioDataItem;
  onSelect: (item: PortfolioItem) => void;
}

const CreativeGallery: React.FC<CreativeGalleryProps> = ({
  group,
  onSelect,
}) => {
  return (
    <section className="scroll-mt-28">
      <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-orbitron text-xl font-medium lg:text-3xl uppercase tracking-[1px]">
            {group.brand}
          </h2>
          <p className="mt-2 max-w-3xl font-poppins text-sm leading-6 text-[#f5f5f5]/65">
            {group.description}
          </p>
        </div>
        <span className="w-fit rounded-full border border-[#00a878]/40 px-3 py-1 font-poppins text-xs text-[#c3f620]">
          {group.media.length} visuals
        </span>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {group.media.map((src, mediaIndex) => {
          const item: PortfolioItem = {
            type: "image",
            title: group.title,
            categoryDesc: group.categoryDesc,
            brand: group.brand,
            description: group.description,
            src,
            mediaIndex,
          };

          return (
            <button
              key={`${src}-${mediaIndex}`}
              type="button"
              onClick={() => onSelect(item)}
              className="group overflow-hidden rounded-lg border-none bg-transparent text-left shadow-xl outline-none ring-[#00a878] transition hover:-translate-y-1 focus-visible:ring-2"
            >
              <div className="overflow-hidden bg-transparent">
                <img
                  src={src}
                  alt={`${item.title} ${mediaIndex + 1}`}
                  loading="lazy"
                  decoding="async"
                  className="h-auto w-full object-contain transition duration-300 group-hover:scale-[1.03]"
                />
              </div>
              {/* <div className="space-y-2 px-4 py-2 text-[#0d1821]">
                <p className="font-poppins text-xs font-semibold uppercase tracking-[0.16em] text-[#00a878]">
                  {item.brand}
                </p>
              </div> */}
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default CreativeGallery;
